export const baseFields = [
  {
    value: 'qualified',
    label: 'Квалификации',
    marker: '#FF0000',
    subColor: 'rgba(255, 0, 0, 0.05)',
    subItems: [
      {
        value: 'qualified_count',
        label: 'Кол-во',
        color: '#FF0000',
        subColor: 'rgba(255, 0, 0, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {
        value: 'qualified_amount',
        label: 'Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'qualified_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'qualified_rd_avg_amount',
        label: 'AVG RD Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'qualified_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'qualified_cr_deposit_2',
        label: 'CR D2',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'qualified_cr_deposit_3',
        label: 'CR D3',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'qualified_cr_deposit_4',
        label: 'CR D4',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'qualified_cr_deposit_5',
        label: 'CR D5',
        type: 'conversion',
        sort: true,
      },
    ],
  },
  {
    value: 'deposit_1',
    label: 'Deposit #1',
    marker: '#FF6F00',
    subColor: 'rgba(255, 111, 0, 0.05)',
    subItems: [
      {
        value: 'deposit_1_count',
        label: 'Кол-во',
        color: '#FF6F00',
        subColor: 'rgba(255, 111, 0, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'deposit_1_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'deposit_1_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'deposit_1_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'deposit_1_cr_deposit_2',
        label: 'CR D2',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'deposit_1_cr_deposit_3',
        label: 'CR D3',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'deposit_1_cr_deposit_4',
        label: 'CR D4',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'deposit_1_cr_deposit_5',
        label: 'CR D5',
        type: 'conversion',
        sort: true,
      },
    ],
  },
  {
    value: 'deposit_2',
    label: 'Deposit #2',
    marker: '#FFAE00',
    subColor: 'rgba(255, 174, 0, 0.05)',
    subItems: [
      {
        value: 'deposit_2_count',
        label: 'Кол-во',
        color: '#FFAE00',
        subColor: 'rgba(255, 174, 0, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'deposit_2_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'deposit_2_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'deposit_2_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'deposit_2_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'deposit_2_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'deposit_2_cr_deposit_3',
        label: 'CR D3',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'deposit_2_cr_deposit_4',
        label: 'CR D4',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'deposit_2_cr_deposit_5',
        label: 'CR D5',
        type: 'conversion',
        sort: true,
      },
    ],
  },
  {
    value: 'deposit_3',
    label: 'Deposit #3',
    marker: '#F6DE04',
    subColor: 'rgba(246, 222, 4, 0.05)',
    subItems: [
      {
        value: 'deposit_3_count',
        label: 'Кол-во',
        color: '#F6DE04',
        subColor: 'rgba(246, 222, 4, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'deposit_3_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'deposit_3_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'deposit_3_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'deposit_3_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'deposit_3_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'deposit_3_cr_deposit_4',
        label: 'CR D4',
        type: 'conversion',
        sort: true,
      },
      {
        value: 'deposit_3_cr_deposit_5',
        label: 'CR D5',
        type: 'conversion',
        sort: true,
      },
    ],
  },
  {
    value: 'deposit_4',
    label: 'Deposit #4',
    marker: '#1ED9A1',
    subColor: 'rgba(30, 217, 161, 0.05)',
    subItems: [
      {
        value: 'deposit_4_count',
        label: 'Кол-во',
        color: '#1ED9A1',
        subColor: 'rgba(30, 217, 161, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'deposit_4_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'deposit_4_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'deposit_4_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'deposit_4_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'deposit_4_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'deposit_4_cr_deposit_5',
        label: 'CR D5',
        type: 'conversion',
        sort: true,
      },
    ],
  },
  {
    value: 'deposit_5',
    label: 'Deposit #5',
    marker: '#17BC72',
    subColor: 'rgba(185, 237, 43, 0.05)',
    subItems: [
      {
        value: 'deposit_5_count',
        label: 'Кол-во',
        color: '#17BC72',
        subColor: 'rgba(185, 237, 43, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'deposit_5_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'deposit_5_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'deposit_5_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
      {
        value: 'deposit_5_avg_time',
        label: 'AVG Время',
        type: 'time',
        sort: true,
      },
      {
        value: 'deposit_5_median_time',
        label: 'Median Время',
        type: 'time',
        sort: true,
      },
    ],
  },
  {
    value: 'deposits',
    label: 'Депозиты',
    marker: '#DD007D',
    subColor: 'rgba(221, 0, 125, 0.05)',
    subItems: [
      {
        value: 'deposits_count',
        label: 'Кол-во',
        color: '#DD007D',
        subColor: 'rgba(221, 0, 125, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'deposits_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'deposits_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'deposits_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
    ],
  },
  {
    value: 'repeats',
    label: 'Повторные Депозиты',
    marker: '#8800DD',
    subColor: 'rgba(136, 0, 221, 0.05)',
    subItems: [
      {
        value: 'repeats_count',
        label: 'Кол-во',
        color: '#8800DD',
        subColor: 'rgba(136, 0, 221, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'repeats_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'repeats_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'repeats_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
    ],
  },
  {
    value: 'players',
    label: 'Игроки',
    marker: '#00DDD9',
    subColor: 'rgba(0, 221, 217, 0.05)',
    subItems: [
      {
        value: 'players_count',
        label: 'Кол-во',
        color: '#00DDD9',
        subColor: 'rgba(0, 221, 217, 0.05)',
        fontWeight: 'bold',
        type: 'count',
        sort: true,
      },
      {value: 'players_sum_amount', label: 'Сумма', type: 'cash', sort: true, fontWeight: 'bold'},
      {
        value: 'players_avg_amount',
        label: 'AVG Сумма',
        type: 'cash',
        sort: true,
        fontWeight: 'bold',
      },
      {
        value: 'players_median_amount',
        label: 'Median Сумма',
        type: 'cash',
        sort: true,
      },
    ],
  },
];

export const fieldsOfGroups = [
  {
    value: 'manager',
    label: 'Менеджер',
    type: 'link',
    rout: '/sales/rd/managers/',
    // isEditLink: '/advertisers/offers/updateOffer',
    // isEdit: false,
    // edit: '/advertisers/offers/',
  },
  {
    value: 'deposit',
    label: 'Депозит',
    type: 'link',
    // rout: '/advertisers/offers/',
    // isEditLink: '/advertisers/offers/updateOffer',
    // isEdit: false,
    // edit: '/advertisers/offers/',
  },
  {
    value: 'offer',
    label: 'Оффер',
    type: 'link',
    rout: '/advertisers/offers/',
    isEditLink: '/advertisers/offers/updateOffer',
    isEdit: false,
    edit: '/advertisers/offers/',
  },
  {value: 'day', label: 'День', type: 'link'},
  {value: 'month', label: 'Месяц', type: 'link'},
  {value: 'year', label: 'Год', type: 'link'},
  {
    value: 'advertiser',
    label: 'Рекламодатель',
    type: 'link',
    rout: '/advertisers/list/',
    isEdit: false,
    isEditLink: '/advertisers/update',
    edit: '/advertisers/list/',
  },
  {value: 'brand', label: 'Бренд', type: 'link', isEdit: true, edit: '/advertisers/brands/'},
  {value: 'country', label: 'Страна', type: 'link'},
  {value: 'pwa', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {value: 'app', label: 'Приложение', type: 'link', rout: '/app/', isTimeConfig: true},
  {
    value: 'traffic',
    label: 'Кампания',
    type: 'link',
    rout: '/tracker/facebook/companies/',
    isFilter: true,
    isTimeConfig: true,
  },
  {value: 'bayer', label: 'Байер', type: 'link', rout: '/tracker/facebook/bayers/'},
  {
    value: 'source',
    label: 'Поток',
    type: 'link',
    rout: '/tracker/facebook/source/',
    isTimeConfig: true,
  },
  {
    value: 'finance',
    label: 'Финансы',
    marker: '#34C77E',
    type: 'link',
    rout: '/tracker/facebook/source/',
  },
  {value: 'pixel', label: 'Пиксели', type: 'link', rout: '/tracker/facebook/pixels/'},
  {value: 'landing', label: 'Лендинг', type: 'link'},
  {value: 'traffics_id', label: 'Кампания', type: 'link', rout: '/tracker/facebook/companies/'},
  {value: 'campaign', label: 'FB Campaigns', type: 'link'},
  {value: 'adset', label: 'FB Adsets', type: 'link'},
  {value: 'ad', label: 'FB Ads', type: 'link'},
  {value: 'app_type', label: 'Платформа', type: 'link', isNotSorted: true},
  {value: 'inf_source', label: 'INF Потоки', type: 'link'},
  {value: 'fb_source', label: 'FB Потоки', type: 'link'},
  {value: 'inf_bayer', label: 'Байер', type: 'link', rout: '/tracker/influence/bayers/'},
  {value: 'fb_bayer', label: 'Байер', type: 'link', rout: '/tracker/facebook/bayers/'},
  {value: 'inf_traffic', label: 'Блогер', type: 'link', rout: '/tracker/influence/bloggers/'},
  {
    value: 'fb_traffic',
    label: 'Кампания',
    type: 'link',
    rout: '/tracker/facebook/companies/',
    isTimeConfig: true,
  },
  {value: 'app_service', label: 'Сервис', type: 'link'},
  {value: 'traffic_type', label: 'Тип Трафика', type: 'link'},
  {value: 'traffic_source', label: 'Источник', type: 'link'},
  {value: 'bot', label: 'Бот', type: 'link'},
  {value: 'channel', label: 'Канал', type: 'link'},
  {value: 'tg_account', label: 'Телеграм Аккаунт', type: 'link'},
  {value: 'channel_group', label: 'Группа Каналов', type: 'link'},
];
